import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { TeamLeadScoringCriteriaRules } from "../types/teams.types";

import { teamsQueryKeys } from "./queryKeyFactory";

type UpdateTeamLeadScoringCriteriaPayload = {
    teamId: number;
    rules: TeamLeadScoringCriteriaRules;
};

export const useUpdateTeamLeadScoringCriteriaMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateTeamLeadScoringCriteriaPayload>({
        mutationFn: ({ teamId, rules }) => salesApiService.teams.updateTeamLeadScoringCriteria(teamId, { rules }),
        // No optimistic patch: a team's `leadScoringCriteria` holds whole rule objects grouped by
        // priority, which only the refetched list can supply from the ids we sent.
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
